<template>
  <div class="alertWindow" :class="{ visible }">
    {{ (text == -1 ? formServerErrorText : text) }}
  </div>
</template>

<script setup>
import { formServerErrorText } from "~/helpers/form";
const props = defineProps(["text"]);
const emit = defineEmits(["closed"]);
const visible = ref();
setTimeout(() => (visible.value = true), 20);
setTimeout(() => {
  visible.value = false;
  emit("closed");
}, 4000);
</script>
